import { Component, Vue, Watch } from 'vue-property-decorator';
import { isEqual } from 'lodash';

import AnalysisStep from '@/components/analysis/steps/AnalysisStep.vue';
import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';

import { StepsKeys } from '@/plugins/podolib/services/analysis';

export enum AnalysisType {
  Walking = 'podosmart',
  Running = 'podorun',
}
export enum AnalysisRunningMode {
  Treadmill = 'treadmill',
  Outdoor = 'outdoor',
}
export enum AnalysisWalkingMode {
  Standard = 'standard',
  Research = 'research',
}

/*export type StepType =
  | {
      type: Type.Walking;
      mode: null;
    }
  | {
      type: Type.Running;
      mode: RunningMode;
    }
  | {
      type: null;
      mode: null;
    };*/

export type StepType = {
  type: AnalysisType | null;
  mode: AnalysisRunningMode | AnalysisWalkingMode | null;
};

@Component({
  components: {
    AnalysisStep,
    ElementBgIcon,
  },
})
export default class AnalysisStepType extends Vue {
  // Main data payload
  data: StepType = null!;

  /**
   * Helper for giving ability to use types and enums in DOM
   */
  tsdom = {
    Type: AnalysisType,
    RunningMode: AnalysisRunningMode,
    WalkingMode: AnalysisWalkingMode,
  };

  // -------------------------------------------------------------------------------------------------------------------

  /**
   * Get manifest entry
   */
  get stepType() {
    return this.$pdc.analysis!.getManifestEntry(StepsKeys.Type);
  }

  // -------------------------------------------------------------------------------------------------------------------

  /**
   * Keep manifest up to date
   */
  @Watch('data', { deep: true })
  onDataChanged(newValue: StepType) {
    if (!isEqual(newValue, this.stepType)) {
      this.$pdc.analysis!.setManifestEntry(StepsKeys.Type, this.data);
    }
  }

  /**
   * Keep local data up to date
   */
  @Watch('stepType', { deep: true, immediate: true })
  onStepComputeChanged(newValue: StepType) {
    if (!isEqual(newValue, this.data)) {
      this.data = { ...this.data, ...this.stepType };
    }
  }

  // -------------------------------------------------------------------------------------------------------------------

  /**
   * Select
   */
  select(data: StepType) {
    this.data = data;

    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('NewAnalysis TypeSelected', data);

    this.next();
  }

  /**
   * Emit "next" event to the parent
   */
  next() {
    this.$emit('next');
  }
}
